export default __webpack_public_path__ + "static/media/fee.6b012670.svg";